import { DTO__database_entity } from '@shared/dto/_database_entity/DTO__database_entity';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';

export class DTOWorkspaceSubscription extends DTO__database_entity {
  /*
   * STATIC FIELDS
   */
  static _class_name_static: string = ENUM__dto_class_name.WORKSPACE_SUBSCRIPTION;

  /*
   * INSTANCE FIELDS
   */
  workspace_id!: string;
  is_personal!: boolean;

  type!: string;
  price!: number;
  started_at!: number;
  ended_at!: number;
}
